import { c as _c } from "react/compiler-runtime";
import { IcoPencil16 } from '@onefootprint/icons';
import type { PlaybookDeploymentResponse, PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Button } from '@onefootprint/ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { getAuthorName } from '../utils';
type ActiveDeploymentProps = {
  deployment?: PlaybookDeploymentResponse;
  playbookVersions: PlaybookVersionNoGraph[];
  onEdit?: () => void;
};
const ActiveDeployment = t0 => {
  const $ = _c(59);
  const {
    deployment,
    playbookVersions,
    onEdit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deployment.active"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  if (!deployment) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <div className="p-4 rounded border border-tertiary text-body-2 text-tertiary">{t2}</div>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== deployment.author) {
    t2 = getAuthorName(deployment.author);
    $[5] = deployment.author;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const authorName = t2;
  let t3;
  if ($[7] !== t) {
    t3 = t(_temp2);
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <h3 className="text-label-1 text-primary">{t3}</h3>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t(_temp3);
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <p className="text-body-2 text-tertiary">{t5}</p>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="flex flex-col gap-1">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== onEdit || $[19] !== t) {
    t8 = onEdit && <Button size="compact" variant="secondary" onClick={onEdit} prefixIcon={IcoPencil16}>{t(_temp4)}</Button>;
    $[18] = onEdit;
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="flex items-start justify-between gap-2">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t) {
    t10 = t(_temp5);
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10) {
    t11 = <h4 className="text-label-2 text-primary">{t10}</h4>;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== deployment.routingPolicy.versions || $[29] !== playbookVersions) {
    let t13;
    if ($[31] !== playbookVersions) {
      t13 = v => {
        const pbVersion = playbookVersions.find(pv => pv.id === v.versionId);
        return <div key={v.versionId} className="flex items-center gap-3 p-3 rounded-lg bg-secondary"><span className="text-label-2 text-primary bg-primary border border-tertiary rounded px-2 py-0.5 shrink-0">v{pbVersion?.version ?? "?"}</span><div className="flex-1 h-2 rounded-full bg-gray-100 overflow-hidden"><div className="h-full rounded-full bg-accent" style={{
              width: `${v.weight}%`
            }} /></div><span className="text-label-2 text-primary w-12 text-right shrink-0">{v.weight}%</span></div>;
      };
      $[31] = playbookVersions;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    t12 = deployment.routingPolicy.versions.map(t13);
    $[28] = deployment.routingPolicy.versions;
    $[29] = playbookVersions;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[33] !== t12) {
    t13 = <div className="flex flex-col gap-2">{t12}</div>;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t11 || $[36] !== t13) {
    t14 = <div className="flex flex-col gap-3">{t11}{t13}</div>;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t) {
    t15 = t(_temp6);
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15) {
    t16 = <span className="text-body-2 text-tertiary">{t15}</span>;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== deployment.createdAt) {
    t17 = format(deployment.createdAt, "MMM d, yyyy 'at' h:mm a");
    $[42] = deployment.createdAt;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t17) {
    t18 = <span className="text-label-2 text-primary">{t17}</span>;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t16 || $[47] !== t18) {
    t19 = <div className="flex flex-col gap-1">{t16}{t18}</div>;
    $[46] = t16;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== authorName || $[50] !== t) {
    t20 = authorName && <div className="flex flex-col gap-1"><span className="text-body-2 text-tertiary">{t(_temp7)}</span><span className="text-label-2 text-primary wrap-anywhere md:wrap-normal">{authorName}</span></div>;
    $[49] = authorName;
    $[50] = t;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t19 || $[53] !== t20) {
    t21 = <div className="border-t border-tertiary pt-4 grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">{t19}{t20}</div>;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t14 || $[56] !== t21 || $[57] !== t9) {
    t22 = <div className="flex flex-col gap-4 p-4 rounded-lg border border-tertiary bg-primary md:p-5">{t9}{t14}{t21}</div>;
    $[55] = t14;
    $[56] = t21;
    $[57] = t9;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  return t22;
};
export default ActiveDeployment;
function _temp($) {
  return $.noActiveDeployment;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.subtitle;
}
function _temp4($_2) {
  return $_2.edit;
}
function _temp5($_3) {
  return $_3.routingPolicy;
}
function _temp6($_4) {
  return $_4.createdAt;
}
function _temp7($_5) {
  return $_5.author;
}